import React, { useState } from "react";
import "./Faqs.css";

const faqs = [
  {
    question: "What is an NFC business card, and how does it work?",
    answer:
      "An NFC business card lets you share your contact details, socials, and business links instantly with just one tap on a smartphone.",
  },
  {
    question: "Can I use a custom NFC business card without an app?",
    answer:
      "Yes, most smartphones can open your NFC card instantly without downloading any extra apps.",
  },
  {
    question: "Is a metal NFC card worth it for professionals?",
    answer:
      "Absolutely. Metal NFC cards give a more premium feel and help create a stronger first impression during meetings and events.",
  },
  {
    question: "Are digital business cards better than paper?",
    answer:
      "Digital NFC business cards are easier to update, more cost-effective, and far more convenient than repeatedly printing paper cards.",
  },
  {
    question: " How fast are BusinessBay.io NFC Cards delivered?",
    answer:
      "Our NFC cards are delivered worldwide within a few working days with secure shipping.",
  },
];

export default function Faqs() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section id="faq" className="faq-section">
      <div className="faq-container">
        <h2 className="faq-title">NFC Business Card FAQs</h2>
        <p className="faq-subtitle">
          Everything you need to know about our smart NFC cards.
        </p>

        <div className="faq-list">
          {faqs.map((item, i) => (
            <div
              key={i}
              className={`faq-item${openIndex === i ? " faq-item--open" : ""}`}
            >
              <button className="faq-question" onClick={() => toggle(i)}>
                <span>{item.question}</span>
                <span className="faq-icon">{openIndex === i ? "−" : "+"}</span>
              </button>
              <div className="faq-answer">
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
